import { render, staticRenderFns } from "./TransactionFlow.vue?vue&type=template&id=1685a352&scoped=true"
import script from "./TransactionFlow.vue?vue&type=script&lang=js"
export * from "./TransactionFlow.vue?vue&type=script&lang=js"
import style0 from "./TransactionFlow.vue?vue&type=style&index=0&id=1685a352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1685a352",
  null
  
)

export default component.exports